export default __webpack_public_path__ + "static/media/golf-ball.d35d9d6d.png";